import { OEButton } from '@openeducation/oe-it-components';
import {
  LiveClassNotification,
  LiveClassTeacherReminderNotification,
} from '@openeducation/oe-it-shared-types';
import React, { useMemo } from 'react';

import { Banner } from '../../atoms/banner/banner';
import { useJoinClass } from '../../hooks/use-join-class';
import { useMessages } from '../../hooks/use-messages';

export interface NotificationBannerProps {
  notification: LiveClassNotification | LiveClassTeacherReminderNotification;
}

export const NotificationClassBanner = ({
  notification,
}: NotificationBannerProps) => {
  const { joinClass } = useJoinClass({
    url: notification.url,
  });

  const { remove } = useMessages();

  const handleJoinClass = () => {
    remove(notification.id);
    joinClass();
  };

  const text = useMemo(() => {
    if (notification.notification === 'SetupTimeStartNotification') {
      return {
        title: 'Setup Time has begun.',
      };
    } else if (notification.notification === 'TeachingTimeStartNotification') {
      return {
        title: 'Teaching Time has begun.',
      };
    } else if (notification.notification === 'FeedbackTimeStartNotification') {
      return {
        title: 'Feedback Time has begun.',
      };
    } else if (notification.type === 'LiveClassNotification') {
      return {
        title: 'Classroom Ready',
        message: notification.notification,
      };
    } else {
      return {
        title: notification.notification,
      };
    }
  }, [notification.notification, notification.type]);

  if (notification.notification === 'EmptyClassNotification') {
    return null;
  }
  return (
    <>
      <Banner
        key={notification.id}
        title={text.title}
        message={text?.message}
        type="info"
        actions={
          notification.type === 'LiveClassNotification' && (
            <OEButton type="accent" onPress={handleJoinClass}>
              Join class
            </OEButton>
          )
        }
      />
    </>
  );
};
